import FieldPrefsTable from './FieldPrefsTable'
import useFieldPrefs from './useFieldPrefs'

const FieldPrefs = () => {
  const fieldPrefsHookProps = useFieldPrefs()
  return <FieldPrefsTable {...fieldPrefsHookProps} />
}

export default FieldPrefs
